import React from 'react';

const Footer = () => (
    <footer className="bg-gray-800 text-white p-4 mt-8 rounded-t-lg text-center text-sm">
        &copy; 2025 The Hungry Fork. All rights reserved.
    </footer>
);

export default Footer;